import './HomePage.scss';

import { DefaultRoutes } from 'Routes';
import InvitationModal from 'components/InvitationModal/InvitationModal';
import { observer } from 'mobx-react-lite';
import useSetPageTitle from 'utilities/useSetPageTitle';
import { useStores } from 'index';
import { useTranslation } from 'react-i18next';
import { HomePageCard } from './HomePageCard/HomePageCard';

import parametersImg from 'images/HomePage/ParametersImg.jpg';
import learningHubImg from 'images/HomePage/LearningHubImg.jpg';
import eventsImg from 'images/HomePage/EventsImg.jpg';
import learningMaterialsShortcutImg from 'images/HomePage/LearningMaterialsShortcut.png';
import modulesAndTestsShortcutImg from 'images/HomePage/ModulesAndTestsShortcut.png';
import parametersShortcutImg from 'images/HomePage/ParametersShortcut.png';

import { ReactComponent as ParametersIcon } from 'images/icons/Adjustment.svg';
import { ReactComponent as LearningHubIcon } from 'images/icons/Book.svg';
import { ReactComponent as EventsIcon } from 'images/icons/Calendar.svg';
import { Link } from 'react-router-dom';
import Paragraph from 'components/TextComps/Paragraph';

export const HomePage = observer(() => {
  const { t } = useTranslation();
  const ps = useStores().profileStore;

  useSetPageTitle({
    title: t('WelcomeUserMessage', {
      ns: 'homePage',
      name: ps.profileData.firstName ? ps.profileData.firstName : '',
    }),
    subtitle: t('WelcomeToTrackmanUniversity', { ns: 'homePage' }),
  });

  return (
    <div className='homepage-container'>
      <div className='shortcut-tiles'>
          <>
            <HomePageCard
              title={t('Parameters', { ns: 'trackmanParameters' })}
              description={t('TrackmanParametersDescription', { ns: 'homePage' })}
              imageSrc={parametersImg}
              route={DefaultRoutes.TrackmanParameters}
              icon={<ParametersIcon />}
            />

            <HomePageCard
              title={t('LearningHub', { ns: 'learningHub' })}
              description={t('LearningHubDescription', { ns: 'homePage' })}
              imageSrc={learningHubImg}
              route={DefaultRoutes.LearningHub}
              icon={<LearningHubIcon />}
            />

            <HomePageCard
              title={t('Events', { ns: 'trackmanEvents' })}
              description={t('EventsDescription', { ns: 'homePage' })}
              imageSrc={eventsImg}
              route={DefaultRoutes.TrackmanEvents}
              icon={<EventsIcon />}
            />
          </>
      </div>
      <InvitationModal />
    </div>
  );
});

export default HomePage;
